<template>
  <v-app-bar app
             class='top_bar_new'
             clipped-left
             elevation="0"
             flat>
    <v-app-bar-nav-icon @click.stop="hideSideBar"></v-app-bar-nav-icon>

    <v-spacer></v-spacer>
    <div class="mr-4 text-center venue_name"><b>Admin Portal</b></div>
    <v-spacer></v-spacer>
    <v-menu offset-y v-model="menu" :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon>
          <v-avatar size="38">
            <view-image
              :image="$store.getters.userInfo.image"
              default_image="user"
            ></view-image>
          </v-avatar>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{
                $store.getters.userInfo.name
              }}</v-list-item-title>

              <v-list-item-subtitle>{{
                $store.getters.userInfo.email
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>

        <v-list dense>
          <v-list-item link @click="gotoProfile" color="#062b47">
            <v-list-item-icon>
              <v-icon color="menu_icon">mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Edit Profile</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link color="#062b47" @click="logOut">
            <v-list-item-icon>
              <v-icon color="menu_icon">mdi-logout-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>
<script>
import { EventBus } from "../../main";
import { mapGetters } from "vuex";
export default {
  data: () => ({
    drawer: true,
    menu: false,
    switch1: false,
  }),
  computed: {
    ...mapGetters({
      checkReadPermission: "checkReadPermission",
    }),
  },
  methods: {
    gotoProfile() {
      this.$router.push({ name: "ProfileSettings" }, () => {});
      this.menu = false;
    },
    hideSideBar() {
      this.drawer = !this.drawer;
      EventBus.$emit("changeIt", this.drawer);
    },
    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    },
  },
};
</script>
<style scoped>
.venue_name {
  font-size: 18px;
}

header.top_bar_new {
  position: sticky !important;
  background: #FFF !important;
  border-bottom: 1px solid rgba(17, 42, 70, 0.10);;
  color: black;
}
</style>
